import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { HighchartsChartModule } from 'highcharts-angular';
import { SharedModule } from '../../app/_shared/shared.module';
import { NavigationModule } from '../navigation/navigation.module';
import { PropertyFilterModule } from '../property-filter/property-filter.module';
import { ClientDashboardRoutingModule } from './client-dashboard-routing.module';
import { ActiveClientsComponent } from './component/active-clients/active-clients.component';
import { ActiveUsersComponent } from './component/active-users/active-users.component';
import { AddContactNoteSheetComponent } from './component/add-contact-note-sheet/add-contact-note-sheet.component';
import { AddExpiredListingsNotesSheetComponent } from './component/add-expired-listings-notes-sheet/add-expired-listings-notes-sheet.component';
import { AgentAnalyticsComponent } from './component/agent-analytics/agent-analytics.component';
import { ClientDashboardComponent } from './component/client-dashboard/client-dashboard.component';
import { ClientDetailSheetComponent } from './component/client-detail-sheet/client-detail-sheet.component';
import { CreateMailSheetComponent } from './component/create-mail-sheet/create-mail-sheet.component';
import { LeadDashboardComponent } from './component/lead-dashboard/lead-dashboard.component';
import { MarketingEffectivenessSheetComponent } from './component/marketing-effectiveness-sheet/marketing-effectiveness-sheet.component';
import { MarketingEffectivenessComponent } from './component/marketing-effectiveness/marketing-effectiveness.component';
import { MultiFileUploadComponent } from './component/multi-file-upload/multi-file-upload.component';
import { NotesComponent } from './component/notes/notes.component';
import { PartnerDashboardComponent } from './component/partner-dashboard/partner-dashboard/partner-dashboard.component';
import { PastClientsListComponent } from './component/past-clients-list/past-clients-list.component';
import { PastClientsComponent } from './component/past-clients/past-clients.component';
import { PropertyListingsComponent } from './component/property-listings/property-listings.component';
import { SaveSearchSheetComponent } from './component/save-search-sheet/save-search-sheet.component';
import { SentMailComponent } from './component/sent-mail/sent-mail.component';
import { UploadPropertyListComponent } from './component/upload-property-list/upload-property-list.component';

@NgModule({
  declarations: [
    ClientDashboardComponent,
    ActiveClientsComponent,
    ClientDetailSheetComponent,
    UploadPropertyListComponent,
    AgentAnalyticsComponent,
    PartnerDashboardComponent,
    LeadDashboardComponent,
    NotesComponent,
    SentMailComponent,
    CreateMailSheetComponent,
    MultiFileUploadComponent,
    SaveSearchSheetComponent,
    MarketingEffectivenessSheetComponent,
    MarketingEffectivenessComponent,
    PropertyListingsComponent,
    ActiveUsersComponent,
    PastClientsComponent,
    PastClientsListComponent,
    AddContactNoteSheetComponent,
    AddExpiredListingsNotesSheetComponent,
    // EmailTemplateComponent
  ],
  imports: [
    PropertyFilterModule,
    CommonModule,
    ClientDashboardRoutingModule,
    NavigationModule,
    MatTabsModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatFormFieldModule,
    HighchartsChartModule,
    MatInputModule,
    MatSortModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    MatCheckboxModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatExpansionModule,
    MatRadioModule,
    MatTooltipModule,
    MatCardModule,
    ReactiveFormsModule,
    SharedModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    AngularEditorModule,
    FormsModule,
    MatChipsModule,
  ],
  exports: [PastClientsListComponent, PastClientsComponent, UploadPropertyListComponent, MarketingEffectivenessComponent],
})
export class ClientDashboardModule { }
